import { SORT_TYPES } from './sortTypes';

export { SORT_TYPES };

export const ARTIST_SUGGESTIONS_COLUMNS = [
  { id: 'name', label: 'Artist', alwaysVisible: true, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'peer_score', label: 'Peer Score', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'peer_venue_count', label: 'Peer Venues', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'peer_last_show', label: 'Last Show At Peer', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'on_tour', label: 'Currently Touring', alwaysVisible: false, defaultVisible: true, sortable: false, sortType: 'text' },
  { id: 'average_capacity_last_12_months', label: 'Avg Cap (12mo)', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'last_show_date', label: 'Last Show Overall', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () =>
  ARTIST_SUGGESTIONS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  ARTIST_SUGGESTIONS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
